const es = global.es; // TODO: Remove dependency!

export default class SymbolStyleTypeUtil {
    /**
     * 
     * @param style 
     * @param geom 
     * @param point 
     * @param resolution 
     * 
     * @returns 
     */
    containsPoint(style, geom, point, resolution: number): boolean {
        let ret = false;

        //TODO: There is no way in the API to get the bounds of a symbol so we use the constants below - need to fix this
        let bounds;  // get bounds of symbol
        switch (style.symbolTypeId) {
            case 8: // teardrop
                bounds = [-0.3,-0.2,0.3,0.8];
                break;

            case 12: // pushpin
                bounds = [-0.5,-0.2,0.2,0.8];
                break;

            default:
                bounds = [-0.5,-0.5,0.5,0.5];
        }

        const size = style.size * resolution;
        for (let b = bounds.length; b-- > 0;) {
            bounds[b] *= size;
        }

        const testBounds = [0,0,0,0];
        es.api.geom.extractPoints(geom, (array, index) => { //test for each point in geom.
            if(!ret){ // only bother with this if it is not already inside the bounds of a symbol
                testBounds[0] = bounds[0] + array[index];
                testBounds[1] = bounds[1] + array[index+1];
                testBounds[2] = bounds[2] + array[index];
                testBounds[3] = bounds[3] + array[index+1];

                ret = es.util.bounds.containsPoint(testBounds, point);
            }
        });

        return ret;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getColor(style) {
        return style.color;
    }

    /**
     * Updates entire style with new color. For example, with styles that contain a label then the new color (or transparency)
     * would be applied to label border, label fill, label shadow, text fill, text border, etc
     * 
     * @param style 
     * @param color 
     * 
     * @returns 
     */
    withColor(style, color) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        style.color = color;
        const label = es.api.style.getTextFromStyle(style);
        if (label) {
            const alpha = es.util.color.getAlpha(color);
            label.color = es.util.color.withAlpha(label.color, alpha);
        }

        return style;
    }

    /**
     * 
     * @param style 
     * @param symbolTypeId 
     * 
     * @returns 
     */
    withSymbol(style, symbolTypeId: number) {
        style = es.util.object.deepCopy(style);
        delete style._hash;

        style.symbolTypeId = symbolTypeId;

        return style;
    }

    /**
     * 
     * @param style 
     * @param size 
     * 
     * @returns 
     */
    withSymbolSize(style, size: number) {
        style = es.util.object.deepCopy(style);
        delete style._hash;

        style.size = size;

        return style;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    mainColor(style) {
        return this.getColor(style);
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style): number[] {
        let x, y;
        x = y = style.size;

        if (style.text) {
            const basicText = es.api.style.getTextFromStyle(style);

            let labelPadding;
            if (basicText) {
                labelPadding = this.getPositionOffSetY(basicText, null, style, 3);
                labelPadding = Math.abs(labelPadding) + (basicText.height * 3);
            }
            x = Math.max(x, 256);
            //y = Math.max(y, (basicText.height * 3) + labelPadding);
            y = Math.max(y, labelPadding);

        }
        //es.log.info("getPaddingPx", [x, y]);

        if (isNaN(x) || isNaN(y)) {
            es.log.error('Invalid coordinates x [' + x + '] y [' + y + ']');
        }

        return [x, y];
    }

    /**
     * 
     * @param text 
     * @param symbolType 
     * @param style 
     * @param numLines 
     * 
     * @returns 
     */
    getPositionOffSetY(text, symbolType, style, numLines: number): number {
        //es.log.info("new getPositionOffSetY", text["position"], text, symbolType, style);

        if (symbolType == null) {
            // assume defaults
            symbolType = {
                offsetX: -0.5,
                offsetY: -0.5,
                labelOffsetX: 0,
                labelOffsetY: 0
            };
        }

        let val = 0;
        if (style.$type == "PolygonStyle") {// TODO BM remove || style.$type == "TextStyle"){
            val = 0;
        } else {
            if (text["position"] == undefined) {
                text.position = "BELOW";
            }

            const styleSize = style["size"] || style.symbol.size; // for some reason, SymbolPlusStyle has size attribute on the symbol sub-object

            if (text.position == "ABOVE") {
                val = 0 + ((styleSize * Math.abs(symbolType.offsetY)) + (text.height * numLines));
            } else if (text.position == "CENTRAL") {
                val = 0 + ((text.height * numLines / 2) - text.height / 2);
            } else if (text.position == "BELOW") {
                // TODO: the "1 - Math.abs" and "+ 10" here don't seem right...
                val = 0 - ((styleSize * (1 - Math.abs(symbolType.offsetY))) + (10) - (styleSize * (Math.abs(symbolType.labelOffsetY))));
            } else {
                throw new Error("position cannot be null");
            }
        }

        if (isNaN(val)) {
            es.log.error("val isNaN");
        }

        //es.log.info(val);
        return val;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * @param pnt 
     * 
     * @returns 
     */
    getFocalPoint(style, geom, pnt): any[] {
        if (geom) {
            if (!pnt) {
                var bounds = es.api.geom.getBounds(geom);
                pnt = [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2];
            } else if(geom[0] === "PT") {
                pnt = [geom[1], geom[2]];
            }
        }

        return pnt;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getText(style) {
        return style.text;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * 
     * @returns 
     */
    getFocalBounds(style, geom) {
        var pnt = this.getFocalPoint(style, geom);
        pnt.push(pnt[0],pnt[1]);

        return pnt;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasDirect(style): boolean {
        return false;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasOverlays(style): boolean {
        return true;
    }
}
